module.exports = __webpack_public_path__ + "static/media/sales.4ac75bd8.svg";